import { updateExportStatus } from '@app/api/export.api';
import { updateStatus as updateImportStatus } from '@app/api/import.api';
import { updateStatus as updateFollowUpStatus } from '@app/api/follow-up.api';
import { updateLabStatus } from '@app/api/labs.api';
import { updateNPStatus } from '@app/api/nominalPayments.api';
import { updateStatus } from '@app/api/prImportFreeSales.api';
import { message } from 'antd';

const labActions: Record<string, string> = {
  DRAFT_TO_PENDING_TA: 'Create Task',
  PENDING_TA_TO_PENDING_PAYMENT: 'Approve Test Assignments',
  PENDING_PAYMENT_TO_PENDING_ITR: 'Make Payment',
  PENDING_PAYMENT_TO_PENDING_SV: 'Make Payment',
  PENDING_SV_TO_PENDING_ITR: 'Submit for Test Results',
  PENDING_ITR_TO_PENDING_ITRA: 'Submit for Result Approval',
  PENDING_ITRA_TO_PENDING_FRS: 'Approve Initial Results',
  PENDING_FRS_TO_PENDING_FA: 'Submit for Final Results',
  PENDING_FA_TO_DONE: 'Approve Final Results',
  DRAFT_TO_PENDING_MA: 'Create Task',
  PENDING_MA_TO_PENDING_PAYMENT: 'Approve Vaccines',
  PENDING_PAYMENT_TO_PENDING_PRODUCTION: 'Make Payment',
  DRAFT_TO_PENDING_IA: 'Create Task',
  PENDING_IA_TO_PENDING_PAYMENT: 'Approve Products',
  PENDING_PAYMENT_TO_PENDING_COLLECTION: 'Make Payment',
};

const npActions: Record<string, string> = {
  DRAFT_TO_PENDING_PAYMENT: 'Create Task',
  PENDING_PAYMENT_TO_DONE: 'Make Payment',
};

export const getNextLabAction = (currentStatus: string, wfActions: string[]): string | null => {
  return wfActions.find((action) => action.startsWith(currentStatus)) || null;
};

export const handleLabWorkflowStatusChange = async (
  id: number,
  currentStatus: string,
  wfActions: string[],
  onSuccess?: (newStatus: string) => void,
) => {
  const action = getNextLabAction(currentStatus, wfActions);
  if (!action) {
    message.error('No valid next action found.');
    return;
  }

  try {
    await updateLabStatus(id, { action });
    message.success(`Status updated to: ${labActions[action] ?? action}`);
    onSuccess?.(action);
  } catch (error) {
    console.error('Error updating lab status:', error);
    message.error('Failed to update task status.');
  }
};

export const handleNPWorkflowStatusChange = async (
  id: number,
  currentStatus: string,
  wfActions: string[],
  onSuccess?: (newStatus: string) => void,
) => {
  const action = getNextLabAction(currentStatus, wfActions);
  if (!action) {
    message.error('No valid next action found.');
    return;
  }

  try {
    await updateNPStatus(id, { action });
    message.success(`Status updated to: ${npActions[action] ?? action}`);
    onSuccess?.(action);
  } catch (error) {
    console.error('Error updating np status:', error);
    message.error('Failed to update task status.');
  }
};

export const handlePRWorkflowStatusChange = async (
  id: number,
  currentStatus: string,
  wfActions: string[],
  onSuccess?: (newStatus: string) => void,
) => {
  const action = getNextLabAction(currentStatus, wfActions);
  if (!action) {
    message.error('No valid next action found.');
    return;
  }

  try {
    await updateStatus(id, { action });
    message.success(`Status updated to: ${npActions[action] ?? action}`);
    onSuccess?.(action);
  } catch (error) {
    console.error('Error updating pr status:', error);
    message.error('Failed to update task status.');
  }
};

export const handleExpWorkflowStatusChange = async (
  id: number,
  currentStatus: string,
  wfActions: string[],
  onSuccess?: (newStatus: string) => void,
) => {
  const action = getNextLabAction(currentStatus, wfActions);
  if (!action) {
    message.error('No valid next action found.');
    return;
  }

  try {
    await updateExportStatus(id, { action });
    message.success(`Status updated to: ${npActions[action] ?? action}`);
    onSuccess?.(action);
  } catch (error) {
    console.error('Error updating pr status:', error);
    message.error('Failed to update task status.');
  }
};

export const handleImpWorkflowStatusChange = async (
  id: number,
  currentStatus: string,
  wfActions: string[],
  onSuccess?: (newStatus: string) => void,
) => {
  const action = getNextLabAction(currentStatus, wfActions);
  if (!action) {
    message.error('No valid next action found.');
    return;
  }

  try {
    await updateImportStatus(id, { action });
    message.success(`Status updated to: ${npActions[action] ?? action}`);
    onSuccess?.(action);
  } catch (error) {
    console.error('Error updating pr status:', error);
    message.error('Failed to update task status.');
  }
};

export const handleFUWorkflowStatusChange = async (
  id: number,
  currentStatus: string,
  wfActions: string[],
  onSuccess?: (newStatus: string) => void,
) => {
  const action = getNextLabAction(currentStatus, wfActions);
  if (!action) {
    message.error('No valid next action found.');
    return;
  }

  try {
    await updateFollowUpStatus(id, { action });
    message.success(`Task status updated to: ${npActions[action] ?? action}`);
    onSuccess?.(action);
  } catch (error) {
    console.error('Error updating pr status:', error);
    message.error('Failed to update task status.');
  }
};
